export default Object.freeze({
  AUTO: 'auto',
  AUTO_CUSTOM_MAX: 'auto_custom_max',
  EXACT: 'exact'
});